// localStorage key 值的前缀, 防止冲突
const prefix = 'delight:';

// 设置本地存储
export function setStorage(key: string, value: any) {
  const val = typeof value === 'object' ? JSON.stringify(value || '{}') : (value || '').toString();
  localStorage.setItem(`${prefix}${key}`, val);
}

// 获取本地存储
export function getStorage(key: string) {
  return localStorage.getItem(`${prefix}${key}`) || '';
}

// 批量删除本地存储
export function removeStorage(key: string | string[]) {
  const keys = typeof key === 'string' ? [key] : key;
  keys.forEach((item) => localStorage.removeItem(`${prefix}${item}`));
}

// 清空本地存储,
// 如果 excludes 存在，则只会排除以 'delight' 开头的 key
export function clearStorage(excludes: string[] = []) {
  const excludeKeys = excludes.map((item) => `${prefix}${item}`);
  const keys = getStorageKeys().filter((item) => excludeKeys.indexOf(item) === -1);
  keys.forEach((key) => localStorage.removeItem(key));
}

// 获取所有本地存储键名(默认获取 `delight:` 前缀的键名)
export function getStorageKeys(keyPrefix = prefix) {
  let result: string[] = [];
  const len = localStorage.length;
  for (let i = 0; i < len; i++) {
    const key = localStorage.key(i) || '';
    const hasPrefix = !keyPrefix || (key.indexOf(keyPrefix) === 0);
    result = hasPrefix ? [...result, key] : [...result];
  }
  return result;
}

// 设置 cookie
export const setCookie = (key: string, value: string, end?: any, path?: string, domain?: string, secure?: boolean) => {
  if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
    return false; // key 值不允许使用 cookie 关键字
  }
  const sKey = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  const sDomain = domain ? `; domain=${domain}` : '';
  const sPath = path ? `; path=${path}` : '';
  const bSecure = secure ? '; secure' : '';
  document.cookie = sKey + setCookieExpire(end) + sDomain + sPath + bSecure;
};

/**
 * 获取 cookie
 * 简化各种限制后，相当于 /(^|.*;)someCookieKey=([^;]*).*$/ 即匹配 ';key=value' 形式的字符串
 * 正则表达式规则解析（以 `;key=value` 字符串为例）：
 *  1. `=` 后面的的值为不包含 `;` 的任意值，如果包含了 `;` 则 `;` 后面的值被视为第二个 key 值
 *  2. `key`的前面可以有 `;`
 *  3. `key` 和 `value` 前后允许有多个空格，但是不允许有换行符
 *  4. 带有 ?: 的括号表达式(即子组)，匹配出来的结果不进行存储(匹配结果里找不到)，为了防止影响后面的 $1 值
 *  5. $1 匹配的结果就是子组 ([^;]*) 匹配的结果，即示例字符串中的 value 值
 */
export const getCookie = (key: string) => {
  const regExp = new RegExp('(?:(?:^|.*;)\\s*' + escapeSpecialChar(key) + '\\s*\\=\\s*([^;]*).*$)|^.*$');
  return decodeURIComponent(document.cookie.replace(regExp, '$1')) || '';
};

// 检查 cookie
export const hasCookie = (key: string) => {
  const regExp = new RegExp('(?:^|;\\s*)' + escapeSpecialChar(key) + '\\s*\\=');
  return regExp.test(document.cookie);
};

// 移除 cookie
export const removeCookie = (key: string, path?: string, domain?: string) => {
  if (!key || !hasCookie(key)) {
    return false;
  }
  const sExpires = '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  const sDomain = domain ? `; domain=${domain}` : '';
  const sPath = path ? `; path=${path}` : '';
  document.cookie = encodeURIComponent(key) + sExpires + sDomain + sPath;
  return true;
};

// 转义特殊字符串
// 相当于将 '.', '-', '+', '*' 转换为 '\\.', '\\-', '\\+', '\\*'
const escapeSpecialChar = (value: string) => encodeURIComponent(value).replace(/[-.+*]/g, '\\$&');

// 设置 cookie 的过期时间
const setCookieExpire = (value?: any) => {
  if (!value) {
    return '';
  }
  let expires = '';
  switch (value.constructor) {
    case Number:
      expires = value === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${value}`;
      break;
    case String:
      expires = `; expires=${value}`;
      break;
    case Date:
      expires = `; expires=${value.toUTCString()}`;
      break;
  }
  return expires;
};
